<template>
  <q-page class="column no-wrap bg-white">
    <GameSetup class="col-grow" />
  </q-page>
</template>

<script setup lang="ts">
import GameSetup from 'components/GameSetup.vue'
</script>
